import React from 'react';
import PropTypes from 'prop-types';
import {List} from "antd";
import {useDispatch, useSelector} from "react-redux";
import contentActions from "@web/redux/content/actions";
import DetailItem from "./timeline/DetailItem";
import useItemVisibilityLogger from "@web/hooks/useItemVisibilityLogger";

ContactDetailsListItem.propTypes = {
  contextPath: PropTypes.string.isRequired,
  itemPath: PropTypes.string.isRequired,
  primary: PropTypes.bool,
};

function ContactDetailsListItem(props) {
  const dispatch = useDispatch();
  const [showDetails, setShowDetails] = React.useState(false);
  const [ref] = useItemVisibilityLogger(props.itemPath);

  /** detect when the component is unmounted */
  React.useEffect(() => {
    return () => {
      dispatch({
        type: "LOG_ITEM_VISIBILITY",
        payload: {inView: false, path: props.itemPath}});
    };
  }, [props.itemPath]);

  const eventsByActivity = useSelector((state) => {
    return state.Content.activity?.[props.contextPath]?.eventsByItem?.[props.itemPath];
  });

  const event = useSelector((state) =>
    state.Content.events[eventsByActivity?.[0]]);

  const onClickItem = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDetails(!showDetails);

    !showDetails &&
    dispatch(contentActions.loadContext(event?.itemPath));
  }

  return <List.Item
    ref={ref}
    key={`list-item-${props.itemPath}`}
  >
    <div className="space space-col" style={{width: '100%'}}>
      {eventsByActivity?.map((eventId) => {
        return <DetailItem
          key={eventId}
          path={event?.itemPath}
          contextPath={props.contextPath}
          primary={props.primary}
          onClick={onClickItem}
          collapsed={false}
        />
      })}
    </div>
  </List.Item>
}

export default ContactDetailsListItem;
